import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'user',
})
export class UserPipe implements PipeTransform {
	transform(value: string | undefined): string {
		return value ? <string>value : 'anonymous';
	}
}
